import React, { useMemo } from 'react'
import { Button, Dropdown, DropdownItem, Icon, Popover } from 'gu-ui-kit'
import clsx from 'clsx'
import styles from 'components/FormControls/form-controls.module.scss'

const renderDropdown = ({
  input: { value, onBlur, onChange, name: inputName },
  meta,
  options,
  buttonClass,
  disabled = false,
}) => {
  const isDisabled = disabled || meta?.submitting
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'selector-' + inputName,
  })

  const triggerProps = useMemo(
    () => (!isDisabled ? { ...bindTrigger(popoverState) } : {}),
    [bindTrigger, popoverState, isDisabled],
  )

  const trigger = (
    <Button
      className={clsx(buttonClass, styles['select-button'], {
        [styles['select-button_opened']]: !!popoverState.isOpen,
      })}
      size={'s'}
      disabled={isDisabled}
      variant={'ghost'}
      grey
      type="button"
      endIcon={<Icon name={'arrow2-big'} color={'inherit'} />}
      {...triggerProps}
    >
      {value}
    </Button>
  )

  return (
    <>
      {isDisabled ? <span style={{ pointerEvents: 'none' }}>{trigger}</span> : trigger}
      <Popover
        {...bindPopover(popoverState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 2,
          horizontal: 'left',
        }}
        disablePortal={true}
        hideBackdrop={true}
      >
        <Dropdown onClick={() => popoverState.isOpen && popoverState.close()}>
          {options.map((item) => (
            <DropdownItem
              key={'selector-' + inputName + '-' + item.value}
              variant={'Body-20'}
              onClick={() => {
                onChange(item.value || null)
                setTimeout(() => {
                  onBlur(item.value || null)
                }, 125)
                popoverState.close()
              }}
            >
              {item.label}
            </DropdownItem>
          ))}
        </Dropdown>
      </Popover>
    </>
  )
}

export default renderDropdown
